import { UISize } from './types';
import { UIViewSpec } from './view';
import { xavis_experiments } from '../y/debug';

export type UIAttachHandler = () => void;
export type UIDetachHandler = () => void;
export type UISizeHandler = (content: UISize, border: UISize) => void;

declare global {
    interface Element {
        ui_attached?: number;
        ui_attach_handlers?: UIAttachHandler[];
        ui_detach_handlers?: UIDetachHandler[];
    }
}

let tracking_attach = false;
let attached_list: Element[] = [];
let attached_list_version = 1;

const on_attach_collection = document.body.getElementsByClassName('x-attach');

let count_attach_handler = 0;
let total_attach_time = 0;

export function getContainerStats() {
    return {
        total_attach_time,
        count_attach_handler,
    };
}

const trackAttachHandler = () => {
    if(xavis_experiments)
        performance.mark('attach-handler');
    const start_t = performance.now();
    count_attach_handler++;
    tracking_attach = false;
    const last_version = attached_list_version++;

    const new_attached_list = Array.from(on_attach_collection);

    for(const e of new_attached_list) {
        if(e.ui_attached != last_version) {
            if(e.ui_attach_handlers) {
                for(const h of e.ui_attach_handlers) {
                    h();
                }
            }

            if(e.ui_watchers) {
                for(const key in e.ui_watchers) {
                    const value = e.ui_get(key as any);
                    if(value !== undefined)
                        e.ui_watchers[key](value, value);
                }
            }
        }
        e.ui_attached = attached_list_version;
    }

    for(const e of attached_list) {
        if(e.ui_attached != attached_list_version) {
            if(e.ui_detach_handlers) {
                for(const h of e.ui_detach_handlers) {
                    h();
                }
            }
        }
    }

    attached_list = new_attached_list;

    total_attach_time += performance.now() - start_t;
};

export function uiTrackAttach(now?: boolean) {
    if(now) {
        trackAttachHandler();
    } else if(!tracking_attach) {
        tracking_attach = true;
        //for containers, we want queueMicrotask, but for attach, we want setTimeout because we want to wait for the next frame
        setTimeout(trackAttachHandler);
        // queueMicrotask(trackAttachHandler);

        //maybe delay individual attach handlers instead
    }
}

export function onAttach(where: UIViewSpec, handler: UIAttachHandler) {
    const elem = where.ui_elem;

    elem.classList.add('x-attach');

    if(elem.ui_attach_handlers)
        elem.ui_attach_handlers.push(handler);
    else
        elem.ui_attach_handlers = [handler];
}

export function onDetach(where: UIViewSpec, handler: UIDetachHandler) {
    const elem = where.ui_elem;

    elem.classList.add('x-attach');

    if(elem.ui_detach_handlers)
        elem.ui_detach_handlers.push(handler);
    else
        elem.ui_detach_handlers = [handler];
}

export function uiGetContext(what: UIViewSpec) {
    return what.ui_elem.closest('.x-context') as HTMLElement | undefined;
}

export function onSize(where: UIViewSpec, handler: UISizeHandler) {
    const observer = new ResizeObserver((entries) => {
        if(entries.length) {
            const e = entries[0];
            if(e.target.isConnected)
                handler([e.contentBoxSize[0].inlineSize, e.contentBoxSize[0].blockSize], [e.borderBoxSize[0].inlineSize, e.borderBoxSize[0].blockSize]);
        }
    });
    observer.observe(where.ui_elem);
}
